// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * 
 */
enum EAdminAccessRoleTyp {
    ROLE_ADMIN = 'ROLE_ADMIN', 
    ROLE_UZIVATEL = 'ROLE_UZIVATEL'
};
export default EAdminAccessRoleTyp;

